<template>
  <form class="physicians-filters" @submit.prevent="updateFilters">
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ locationLabel }}</div>
        <select class="form-select" v-model="location">
          <option value="">{{ selectLabel }} {{ locationLabel }}</option>
          <option
            v-for="location in store.filterOptions.locations"
            :key="location"
            :value="location"
            >
            {{ location.city }}, {{ location.state }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ zipCodeLabel }}</div>
        <input type="text" class="form-control" :placeholder="zipCodeLabel" v-model="zipCode">
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ languageOtherThanEnglishLabel }}</div>
        <select class="form-select" v-model="language">
          <option value="">{{ selectLabel }} {{ languageLabel }}</option>
          <option
            v-for="language in store.filterOptions.languages"
            :key="language"
          >
            {{ language }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ genderLabel }}</div>
        <select class="form-select" v-model="gender">
          <option value="">{{ selectLabel }} {{ genderLabel }}</option>
          <option
            v-for="gender in store.filterOptions.genders"
            :key="gender"
          >
            {{ gender }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <label class="w-100">
        <div class="physicians-filter-label">{{ specialtyLabel }}</div>
        <select class="form-select" v-model="specialty">
          <option value="">{{ selectLabel }} {{ specialtyLabel }}</option>
          <option
            v-for="specialty in store.filterOptions.specialties"
            :key="specialty"
          >
            {{ specialty }}
          </option>
        </select>
      </label>
    </div>
    <div class="physicians-filter-item">
      <div class="d-flex justify-content-start mx-n1">
        <div class="p-1">
          <button type="submit" class="btn btn-primary">
            {{ submitLabel }}
          </button>
        </div>
        <div class="p-1">
          <button type="button" class="btn btn-link text-decoration-underline" @click="clearFilters">
            {{ clearLabel }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { PhysiciansStore } from '../stores/PhysiciansStore'

export default {
  props: {
    locationLabel: {
      type: String,
      required: true
    },
    zipCodeLabel: {
      type: String,
      required: true
    },
    languageLabel: {
      type: String,
      required: true
    },
    languageOtherThanEnglishLabel: {
      type: String,
      required: true
    },
    genderLabel: {
      type: String,
      required: true
    },
    specialtyLabel: {
      type: String,
      required: true
    },
    selectLabel: {
      type: String,
      required: true
    },
    submitLabel: {
      type: String,
      required: true
    },
    clearLabel: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      valuesInitialized: false,
      location: '',
      zipCode: '',
      language: '',
      gender: '',
      specialty: ''
    }
  },
  computed: {
  },
  watch: {
  },
  setup() {
    const store = PhysiciansStore()
    store.getFilterOptions()
    return {
      store
    }
  },
  created() {
  },
  mounted() {
    this.store.$subscribe((mutation, state) => {
      if (!this.valuesInitialized && state.urlParametersStatus === 'ready') {
        this.initializeValues()
      }
    })
  },
  methods: {
    initializeValues() {
      this.valuesInitialized = true
      if (this.store.query.city && this.store.query.state) {
        this.location = { city: this.store.query.city, state: this.store.query.state }
      }
      if (this.store.query.zipCode) {
        this.zipCode = this.store.query.zipCode
      }
      if (this.store.query.language) {
        this.language = this.store.query.language
      }
      if (this.store.query.gender) {
        this.gender = this.store.query.gender
      }
      if (this.store.query.specialty) {
        this.specialty = this.store.query.specialty
      }
    },
    updateFilters() {
      this.store.updateFilters(this.location, this.zipCode, this.language, this.gender, this.specialty)
    },
    clearFilters() {
      this.location = ''
      this.zipCode = ''
      this.language = ''
      this.gender = ''
      this.specialty = ''
      this.updateFilters()
    }
  },
  components: {
  }
}
</script>
